<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-23 15:57:51
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-08-04 14:54:28
 * @Description: 描述
 -->
<template>
  <a-row type="flex">
    <template v-for="(widget, index) in list">
      <a-col v-show="showCol(widget)"
        :class="className(widget)"
        :key="index"
        v-bind="span(widget)">
        <component :is="getName(widget.type)"
          :lang="lang"
          :widget="widget">
          <template v-for="key in formSlotsKeys"
            v-slot:[key]="slotProps">
            <slot :name="key"
              v-bind="slotProps"></slot>
          </template>
        </component>
      </a-col>
    </template>
  </a-row>
</template>
<script>
import widgetType from './widgetType';

export default {
  name: 'wgList',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    lang: {
      type: String,
      default() {
        return process.env.VUE_APP_DEFAULT_LANG;
      },
    },
  },
  inject: ['formContext'],
  computed: {
    formSlotsKeys() {
      if (this.formContext) {
        return Object.keys(this.formContext.formSlots);
      }
      return [];
    },
  },
  methods: {
    getName(type) {
      return widgetType[type];
    },
    showCol(widget) {
      if (widget.type === 'hidden' || widget.options.visible === false) {
        return false;
      }
      return !widget.options.hidden;
    },
    className(widget) {
      if (widget.options.nowrap === true) {
        return 'wg-grid-col nowrap-col';
      }
      return 'wg-grid-col';
    },
    span(widget) {
      if (widget.type === 'card') {
        return {
          span: widget.options.span,
        };
      }
      if (widget.options.nowrap === true) {
        return {
          span: widget.options.span,
        };
      }
      return {
        xs: 24,
        sm: widget.options.span > 12 ? widget.options.span : 12,
        md: widget.options.span,
        lg: widget.options.span,
        xl: widget.options.span,
      };
    },
  },
};
</script>
